import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Delete Forever"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-delete-forever',
    templateUrl: './icon-delete-forever.component.html',
    styleUrls: ['./icon-delete-forever.component.scss'],
    standalone: false
})
export class IconDeleteForeverComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
